export enum DataHubActions {
  BLOCK = 'block',
  CREATE = 'create',
  DELETE = 'delete',
  OPEN = 'open',
  POST = 'post',
  SAVE = 'save',
  SCHEDULE = 'schedule',
  SETUP = 'setup',
  VIEW = 'view'
}

export type DataHubActionTypes = `${DataHubActions}`
